export default __webpack_public_path__ + "static/media/logoChavo.37f1f95c.png";